import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { loginUserThunk } from "../../../toolkit/slices/users/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import "./sigin.css";
import "../../containers/AuthUserContainer/AuthUserContainer.css";
import { hasStoredAuthSession } from "../../../../utils/authSession";

function SignIn({ setSignUpFlag }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user._id);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userId && hasStoredAuthSession()) {
      navigate("/dashboard");
    }
  }, [userId, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await dispatch(loginUserThunk(values));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="SignInForm">
      <div className="">
        <p class="sign-in-text">Sign in to your account</p>
      </div>
      <br />
      <Form name="login" onFinish={onFinish}>
        <Form.Item
          name="email"
          rules={[{ required: true, message: "Email Address" }]}
        >
          <Input placeholder="Email Address" className="underline-input" />
        </Form.Item>
        <br />
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password className="underline-input" placeholder="Password" />
        </Form.Item>
        <br />
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{
              width: "100%",
              background: "linear-gradient(70deg,#FFCB10, #FFF200)",
              border: "none",
            }}
          >
            Sign In
          </Button>
        </Form.Item>

        {/* <Form.Item>
        <div className="auth-divider">
          <span>.</span>
          <div>OR</div>
          <span>.</span>
        </div>
        </Form.Item>
        <Form.Item>
          <Button onClick={()=>setSignUpFlag(prev=>!prev)} style={{ width: '100%' }}>
            Sign Up
          </Button>
        </Form.Item> */}
      </Form>
    </div>
  );
}

export default SignIn;
